import { render, staticRenderFns } from "./service-safety-detail.vue?vue&type=template&id=6348bc94&scoped=true"
import script from "./service-safety-detail.vue?vue&type=script&lang=js"
export * from "./service-safety-detail.vue?vue&type=script&lang=js"
import style0 from "./service-safety-detail.vue?vue&type=style&index=0&id=6348bc94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6348bc94",
  null
  
)

export default component.exports